export default __webpack_public_path__ + "static/breadcrumbs-parts-6a0d2940a98606d1381e5dd79966c29f.png";